import styled from 'styled-components';

import { mediaConfined } from '@xing-com/layout-tokens';
import { CenterContainer as InnerCenterContainer } from '@xing-com/platform-layout-view-wrapper';
import {
  space3XL,
  space4XL,
  space5XL,
  spaceXL,
  xdlColorBackgroundSecondary,
  xdlColorCardHero01,
} from '@xing-com/tokens';

export const LoggedOutContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: ${space5XL};
  width: 100%;
`;
export const BottomContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space3XL};
  padding-top: ${space3XL};
  padding-bottom: ${space3XL};

  @media ${mediaConfined} {
    gap: ${space5XL};
    padding-top: ${space4XL};
    padding-bottom: ${space5XL};
  }
`;

export const HightlightSection = styled.div`
  padding-bottom: ${space3XL};

  background-color: ${xdlColorCardHero01};

  @media ${mediaConfined} {
    padding-bottom: ${space4XL};
  }

  @media (prefers-color-scheme: dark) {
    background-color: ${xdlColorBackgroundSecondary};
  }
`;

export const CenterContainer = styled(InnerCenterContainer)`
  flex-direction: column;
`;

export const BreadcrumbsContainer = styled.div`
  padding: 0 ${spaceXL};
  max-width: 1520px;
  margin: 0 auto;
  width: 100%;
`;
